import React from 'react';
import {Link} from "react-router-dom";
import ThemeNavbar from './ThemeNavbar'

function ThemeLeftMenuSideBar() {

  return (
    <div className="left-menu-sidebar d-flex min-vh-100 flex-column">
      <div className="sidebar-brand-icon">
        <div className="menu-logo-image">
          <Link to="">
            <img alt="manpower-menu-logo" src={process.env.PUBLIC_URL + '/assets/images/manpower-top-logo.png'} />
          </Link>
        </div>
      </div>
      <div className="sidebar-divider"></div>
        <ThemeNavbar />
    </div>
  )
}

export default ThemeLeftMenuSideBar